export enum BedStatus {
	AVAILABLE = 0,
	UNAVAILABLE = 1,
	RESERVED = 2,
	OCCUPIED = 3,
}

export const bedStatusMessages = {
	[BedStatus.AVAILABLE]: "Disponível",
	[BedStatus.UNAVAILABLE]: "Indisponível",
	[BedStatus.RESERVED]: "Reservado",
	[BedStatus.OCCUPIED]: "Ocupado",
};
